"use client";

import { motion } from "framer-motion";

interface MissionSectionProps {
  onDownloadClick?: () => void;
}

export function MissionSection(_props: MissionSectionProps) {
  return (
    <div className="relative py-32 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <motion.h2
          className="text-4xl lg:text-6xl font-bold text-white mb-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Bring a digital companion to every person, on every device.
        </motion.h2>

        <motion.p
          className="text-xl lg:text-2xl text-white/80 mb-12 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Empowering humanity with intelligent productivity
        </motion.p>
      </div>

      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none" />
    </div>
  );
}
